import { datadogRum } from "@datadog/browser-rum";
import { datadogLogs } from "@datadog/browser-logs";

export function isDatadogEnabled() {
  const isLocalhost = window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1";
  const isDevelopment = process.env.NODE_ENV === "development";
  return !isDevelopment && !isLocalhost && !!process.env.REACT_APP_DATADOG_APPLICATION_ID;
}

export function setDatadogGlobalContext(context) {
  if (!isDatadogEnabled()) return;
  const entries = Object.entries(context).filter(([, value]) => value != null && value !== "");
  entries.forEach(([key, value]) => datadogRum.setGlobalContextProperty(key, value));
  entries.forEach(([key, value]) => datadogLogs.setGlobalContextProperty(key, value));
}
